import { createSlice } from '@reduxjs/toolkit'

import { IStripeReducers, IStripeState } from './stripe.types'

const initialState: IStripeState = {
  loading: false,
  error: false,
  clientSecret: '',
  retrieveMessage: '',
  accountId: '',
}

const { actions, reducer } = createSlice<IStripeState, IStripeReducers, 'stripe'>({
  name: 'stripe',
  initialState,
  reducers: {
    confirmPaymentRequest: (state) => {
      state.loading = true
      state.error = false
    },
    confirmPaymentSuccess: (state, action) => {
      state.loading = false
      state.retrieveMessage = action.payload.message
    },
    confirmPaymentFailure: (state) => {
      state.loading = false
      state.error = true
    },
    setClientSecret: (state, action) => {
      state.clientSecret = action.payload.clientSecret
    },
    setAccountId: (state, action) => {
      state.accountId = action.payload.accountId
    },
  },
})

export { actions as StripeActions }

export { reducer as stripeReducer }
